import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IMessageSelector } from "src/app/pages/main/pages/admin/pages/admin-settings/pages/admin-settings-messages/admin-settings-messages.component";
import { environment } from "src/environments/environment";

const MOUNTS: IMessageSelector[] = [
  {
    id: 0,
    name: 'Sausis',
    value: 1
  },
  {
    id: 1,
    name: 'Vasaris',
    value: 2
  },
  {
    id: 2,
    name: 'Kovas',
    value: 3
  },
  {
    id: 3,
    name: 'Balandis',
    value: 4
  },
  {
    id: 4,
    name: 'Gegužė',
    value: 5
  },
  {
    id: 5,
    name: 'Birželis',
    value: 6
  },
  {
    id: 6,
    name: 'Liepa',
    value: 7
  },
  {
    id: 7,
    name: 'Rugpjūtis',
    value: 8
  },
  {
    id: 8,
    name: 'Rugsėjis',
    value: 9
  },
  {
    id: 9,
    name: 'Spalis',
    value: 10
  },
  {
    id: 10,
    name: 'Lapkritis',
    value: 11
  },
  {
    id: 11,
    name: 'Gruodis',
    value: 12
  }
]

@Injectable()
export class AdminSettingsMessagesService {
  
  constructor(private http: HttpClient) {}

  getMountsList() {
    return MOUNTS;
  }

  getXls(year: number, month: number) {
    const url = environment.apiUrl + '/operator/report';
    return this.http.post(url, {
      month,
      year
    }, {
      responseType: 'blob'
    })
  }
}